import axios from 'axios';
import { getAuthHeader } from './authService';
import { API_BASE_URL } from '../config/constants';

/**
 * Axios instance for API requests with default configuration
 */
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add auth token to every request
api.interceptors.request.use(
  config => {
    const headers = getAuthHeader();
    if (headers.Authorization) {
      config.headers.Authorization = headers.Authorization;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // Authorization error - could redirect to login
      if (error.response.status === 401) {
        console.error('Unauthorized request');
      }
      
      // Forbidden error
      if (error.response.status === 403) {
        console.error('Forbidden request');
      }
    }
    return Promise.reject(error);
  }
);

export default api; 